import { useEffect, useState } from 'react';
import BrandLogo from './BrandLogo';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <a href="#top" className="nav__brand" onClick={close}>
          <BrandLogo size="sm" />
          <span className="nav__name">Saarthi</span>
        </a>

        <button
          type="button"
          className={`nav__toggle ${open ? 'nav__toggle--open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        <nav className={`nav__links ${open ? 'nav__links--open' : ''}`}>
          <a href="#instant-ride" onClick={close} className="nav__link nav__link--instant">
            Instant ride
          </a>
          <a href="#hire-a-car" onClick={close} className="nav__link nav__link--hire">
            Hire a car
          </a>
          <a href="#referrals" onClick={close}>
            Referral code
          </a>
          <a href="/support" onClick={close} className="nav__cta nav__cta--support">
            Support
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
